<ng-container *transloco="let t">
  <div class="cbu-form">
    <pxw-text-field
      [label]="t('subscription.cbuHolderName')"
      [placeholder]="t('subscription.cbuHolderName')"
      [(value)]="cbuModel().holderName"
      [rules]="[{ type: 'required', message: t('subscription.cbuHolderNameRequired') }]"
      stylingMode="underlined"
    ></pxw-text-field>

    <pxw-text-field
      [label]="t('subscription.cbuNumber')"
      [placeholder]="t('subscription.cbuNumber')"
      [helper]="t('subscription.cbuNumberHelper')"
      [(value)]="cbuModel().cbuNumber"
      [maxLength]="22"
      [rules]="[
        { type: 'required', message: t('subscription.cbuNumberRequired') },
        { type: 'pattern', pattern: cbuPattern, message: t('subscription.cbuNumberPattern') }
      ]"
      stylingMode="underlined"
    ></pxw-text-field>

    <pxw-text-field
      [label]="t('subscription.cbuHolderIdNumber')"
      [placeholder]="t('subscription.cbuHolderIdNumber')"
      [(value)]="cbuModel().holderIdNumber"
      [mask]="documentMask()"
      [rules]="[{ type: 'required', message: t('subscription.cbuHolderIdNumberRequired') }]"
      stylingMode="underlined"
    >
      <dx-select-box
        class="addon-prepend"
        [value]="selectedDocumentType()"
        [dataSource]="documentTypes"
        valueExpr="value"
        displayExpr="label"
        (onValueChanged)="onDocumentTypeChange($event.value)"
        stylingMode="underlined"
        [width]="110"
        [inputAttr]="{ 'aria-label': t('subscription.documentType') }"
      ></dx-select-box>
    </pxw-text-field>

    <div class="ui-input">
      <label class="ui-label">{{ t('subscription.cbuBankId') }}</label>
      <dx-select-box
        [(value)]="cbuModel().bankId"
        [items]="sortedBanks()"
        [searchEnabled]="true"
        displayExpr="name"
        valueExpr="id"
        [placeholder]="t('subscription.cbuBankId')"
        stylingMode="underlined"
        validationMessageMode="always"
        [inputAttr]="{ 'aria-label': t('subscription.cbuBankId') }"
      >
        <dx-validator>
          <dxi-validation-rule
            type="required"
            [message]="t('subscription.cbuBankIdRequired')"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-select-box>
    </div>
  </div>
</ng-container>
